<form #ccForm ngNoForm id="ccForm" method="post" [action]="creditCardUrl">
    <input type="hidden" name="state" value="CO">
    <input type="hidden" name="amount" value={{amount}}>
    <input type="hidden" name="externalId" value={{transactionId}}>
</form>